module.exports = __webpack_public_path__ + "static/media/icon-linkedin.61df99e8.svg";